'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var Grid = _interopDefault(require('@material-ui/core/Grid'));
var styledComponents = require('./styled-components.js');

var BorderlessButton = function (props) {
    var title = props.title, onClick = props.onClick, _a = props.disabled, disabled = _a === void 0 ? false : _a, icon = props.icon, dataTestId = props["data-testid"], _b = props.style, style = _b === void 0 ? {} : _b, _c = props.size, size = _c === void 0 ? 'medium' : _c, _d = props.justifyContent, justifyContent = _d === void 0 ? 'center' : _d;
    return (React__default.createElement(styledComponents.StyledButton, { onClick: onClick, disabled: disabled, "data-testid": dataTestId, style: style, size: size },
        React__default.createElement(Grid, { container: true, justify: justifyContent },
            icon && (React__default.createElement(Grid, { item: true, "data-testid": 'display-icon' }, icon)),
            React__default.createElement(Grid, { item: true },
                React__default.createElement("span", null, title)))));
};

module.exports = BorderlessButton;
